<template>
  <v-container fluid id="coming-soon-page" fill-height>
    <v-row class="justify-center">
      <v-col xs="10" md="8" lg="8">
        <h1 id="title" class="mb-12">COMING SOON</h1>
        <a
          href="https://discord.gg/9RrRWqFrD4"
          target="_blank"
          class="glow-button"
          ><v-icon large color="#FFFFFF" class="mr-2">mdi-discord</v-icon>Join
          our discord</a
        >
        <v-col cols="12" class="text-center mt-6">
          <a
            href="https://instagram.com/hybrid_factions?utm_medium=copy_link"
            target="_blank"
            class="dark-button mr-3"
            ><v-icon color="#FFFFFF" class="icon mr-2">mdi-instagram</v-icon
            >Instagram</a
          >
          <a
            href="https://twitter.com/hybridfacti0ns?s=21"
            target="_blank"
            class="dark-button"
            ><v-icon color="#FFFFFF" class="icon mr-2">mdi-twitter</v-icon
            >Twitter</a
          >
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ComingSoon",

  data: () => ({}),
};
</script>
<style scoped>
.glow-button {
  text-decoration: none;
  color: white !important;
  background: linear-gradient(
    135deg,
    rgba(217, 173, 89, 1) 0%,
    rgba(162, 128, 62, 1) 100%
  );
  padding: 15px 40px;
  border-radius: 4px;
  font-weight: normal;
  box-shadow: 0 0 15px rgb(255, 255, 255, 0.4) !important;
  font-size: 2vw !important;
  cursor: pointer;
}
.dark-button {
  text-decoration: none;
  color: white !important;
  background: #2c2f33;
  padding: 10px 30px;
  border-radius: 4px;
  font-weight: normal;
  box-shadow: 0 2px 15px rgb(44, 47, 51, 0.4) !important;
  z-index: 2;
}
#title {
  color: white !important;
  font-weight: 500 !important;
  font-size: 5.5vw !important;
  line-height: 5vw !important;
  text-align: center;
  z-index: 2;
}
#paragraph {
  color: white !important;
  font-weight: 300 !important;
  font-size: 1.2vw !important;
  line-height: 1.2vw !important;
  z-index: 2;
}
#coming-soon-page {
  color: white;
  height: calc(100vh);
  position: relative;
  overflow: hidden;
  text-align: center;
  background: url(../assets/bg-coming-soon.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
#orb-1 {
  position: absolute;
  top: -10vw;
  left: -20%;
  z-index: 0;
  width: 45vw;
  opacity: 0.8;
}
#orb-2 {
  position: absolute;
  right: -10%;
  bottom: -20vw;
  z-index: 0;
  width: 70vw;
  opacity: 0.8;
}
#cats-group {
  position: absolute;
  right: -15%;
  bottom: -4vw;
  width: 70vw;
  z-index: 1;
}
@media screen and (max-width: 961px) {
  #paragraph {
    margin-top: 15px !important;
    font-size: 2vw !important;
    line-height: 2vw !important;
  }
  #join-now-page {
    margin-top: 0px;
    height: calc(100vh - 56px);
  }
}

@media screen and (max-width: 821px) {
  #title {
    font-size: 9vw !important;
    line-height: 8vw !important;
  }

  #paragraph {
    font-size: 3vw !important;
    line-height: 3vw !important;
  }

  .glow-button,
  .dark-button {
    font-size: 3vw !important;
  }
  .numbers {
    font-size: 3vw;
    z-index: 4;
  }
  .numbers h2 {
    font-size: 5vw !important;
  }
  #cats-group {
    right: -15%;
    width: 90vw;
  }
}
@media screen and (max-width: 426px) {
  #paragraph {
    font-size: 4vw !important;
    line-height: 4vw !important;
  }
  #title {
    font-size: 11vw !important;
    line-height: 11vw !important;
  }
  .numbers {
    font-size: 5vw;
  }
  .numbers h2 {
    font-size: 7vw !important;
  }
  #cats-group {
    right: -15%;
    width: 130vw;
  }
  #orb-2 {
    right: -10%;
    width: 120vw;
  }
}
@media screen and (max-width: 376px) {
  #paragraph {
    font-size: 3vw !important;
    line-height: 3vw !important;
  }
  #title {
    font-size: 8vw !important;
    line-height: 8vw !important;
  }
  .numbers {
    font-size: 4vw;
  }
  .numbers h2 {
    font-size: 6vw !important;
  }
  #cats-group {
    right: 3%;
    width: 100vw;
  }
  #orb-2 {
    right: 3%;
    width: 100vw;
  }
}
@media screen and (max-width: 361px) {
  #paragraph {
    font-size: 5vw !important;
    line-height: 5vw !important;
  }
  #title {
    font-size: 10vw !important;
    line-height: 10vw !important;
  }
  .numbers {
    font-size: 5vw;
  }
  .numbers h2 {
    font-size: 7vw !important;
  }
  #cats-group {
    right: 3%;
    width: 100vw;
  }
  #orb-2 {
    right: 3%;
    width: 100vw;
  }
}
</style>
